import { axios } from '@/services/axios';

export const updateTRSNode = (nodeData) => {
    const res = axios.put('/TRSNode', nodeData);
    return res;
};
